import React from 'react';
import { BaseURL } from '../../config/axios';
import { Link } from 'react-router-dom';

const Result = ({ result }) => {
    return (
        <>
            {result && <div className="mt-10">
                <h2 className="text-xl font-semibold text-gray-700">نتیجه شما</h2>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 grid-cols-1 gap-3 mt-4">
                    {result.map((s, i) => (
                        <Link to={`/product/${s.slug}`}
                            className="bg-[#f6f6f6] flex flex-col items-center duration-300 md:hover:scale-105 overflow-hidden sm:rounded-lg"
                            key={s.id}>
                            <div className="grow w-full border-b">
                                <div className="max-h-[250px] h-full overflow-hidden centerOfParent">
                                    <img placeholder='blur' blurDataURL='/images/placeholder-1.png'
                                        width={100} height={100}
                                        src={BaseURL + s.images[0]?.path} title={s.title}
                                        alt={s.title || s.title_persian}
                                        className="object-contain w-full h-full max-h-[250px]"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col items-center p-2 w-full">
                                <h4 className="w-full  font-bold text-center line-clamp-1">
                                    {s.title_persian}
                                </h4>
                                <div className="w-full py-2 text-center text-sm border-b">
                                    {s.artist?.title_persian}
                                </div>
                                {!!s.year &&
                                    <div className="w-full py-2 centerOfParent  gap-1 text-xs border-b">
                                        {s.year}
                                    </div>}
                                <button
                                    className="bg-primary px-4 py-2 mt-2 rounded-md text-white hover:opacity-80">
                                    انتخاب سایز و قاب
                                </button>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>}
        </>
    );
};

export default Result;